export default __webpack_public_path__ + "static/media/check-3.8d8c16ff.svg";